import kadvice from "kadvice";
import { useEffect, useState } from "react";

// const setStorage = (key, value) => {
//     localStorage.setItem(key, JSON.stringify(value));
// };

// const getStorage = (key) => {
//     const item = localStorage.getItem(key);
//     return JSON.parse(item);
// };

function App() {
    const [dailyAdvice, setDailyAdvice] = useState(null);

    useEffect(() => {
        setDailyAdvice(kadvice.daily());
    }, []);

    // const advices = useMemo(() => {
    //     return kadvice.get(2);
    // }, []);

    // const cnt = useMemo(() => {
    //     return getStorage("cnt");
    // }, []);

    // const [dailyAdvice, setDailyAdvice] = useState(advices[0]);

    // useEffect(() => {
    //     const midNight = getStorage("midnight");
    //     const curTime = new Date().getTime();

    //     if (curTime >= midNight) {
    //         setStorage("midnight", new Date().setHours(24, 0, 0, 0));
    //         if (advices[cnt + 1]) {
    //             setStorage("cnt", cnt + 1);
    //             setDailyAdvice(advices[cnt + 1]);
    //         } else {
    //             setDailyAdvice(advices[0]);
    //             setStorage("cnt", 0);
    //         }
    //     }
    // }, [advices, cnt]);

    // useEffect(() => {
    //     if (getStorage("midnight")) {
    //         return;
    //     }

    //     setStorage("midnight", new Date().setHours(24, 0, 0, 0));
    // }, []);

    // useEffect(() => {
    //     if (getStorage("cnt")) {
    //         return;
    //     }

    //     setStorage("cnt", 0);
    // }, []);

    return (
        <div className="app">
            {dailyAdvice && (
                <>
                    <div className="message">{dailyAdvice.message}</div>
                    <small className="author">-{dailyAdvice.author}-</small>
                    <em>
                        <small className="author-profile">
                            {dailyAdvice.authorProfile}
                        </small>
                    </em>
                </>
            )}
            <button
                type="button"
                onClick={() => setDailyAdvice(kadvice.random())}
            >
                random
            </button>
        </div>
    );
}

export default App;
